import { render, staticRenderFns } from "./member-bookings.vue?vue&type=template&id=beb97156&"
import script from "./member-bookings.vue?vue&type=script&lang=js&"
export * from "./member-bookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports